import { Theme } from '@eversports/react-components/design-tokens/theme'
import { makeStyles } from '@mui/styles'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
  highlightBox: {
    backgroundColor: theme.palette.beigeLight,
    borderRadius: theme.borderRadii.default,
    padding: theme.layoutSpacing.default,
  },
}))

const HighlightBox: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const classes = useStyles()

  return <div className={classes.highlightBox}>{children}</div>
}

export default HighlightBox
